import { useState, useEffect } from "react";
import { Button } from "ui/compat";
import { ExampleNoticeWrapper } from "styles";

export const ExampleNotice = ({ projectSlug }) => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(`ExampleNotice.${projectSlug}`);
    if (!consent) {
      setShowConsent(true);
    }
    // eslint-disable-next-line
  }, []);

  const handleAccept = () => {
    localStorage.setItem(`ExampleNotice.${projectSlug}`, "hide");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <ExampleNoticeWrapper>
      <div>
        <h6>This is an example project</h6>
        <p>
          This page is a showcase shared by a Lumo Pages customer. If you submit
          the form, your information may be saved, but you will not receive a
          response.
        </p>
      </div>

      <Button secondary size="small" onClick={handleAccept}>
        Hide notice
      </Button>
    </ExampleNoticeWrapper>
  );
};
